<div>
  <form style="display: flex;justify-content: space-evenly;" [formGroup]="radioform">
    <span *ngFor="let weather of weatherImages" style="margin-right: 20px;">
      <!-- <input type="radio" name="weatherList" formControlName="weatherList" [value]="weather.weatherKey"> -->
      <label>
        <img class="weatherImg" [src]="weather.imgUrl" [title]="weather.weatherType" (click)="onImgClick(weather.weatherKey)">
      </label>
      <br>
      <span style="display: flex;justify-content: center;"><input type="radio" name="weatherList" formControlName="weatherList" [value]="weather.weatherKey">
        <b>{{weather.weatherType}}</b></span>
    </span>
  </form>
</div>
<div class="footer rej_req">
  <span class="align-right col-md-6 secondory_btn">
    <button class="btn btn-primary" [disabled]="!radioform.valid" (click)="onSubmit()">Submit</button>
  </span>
</div>